import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ApprovalTypeLevelUserGroupListItemComponent = ({ item, index, userGroups, dispatch, validation }) => {
  const { t } = useTranslation();
  const setDefaultUserGroup = propertyValue => {
    dispatch({ type: 'setDefaultUserGroup', propertyValue, index });
  };

  const onPropertyChanged = (propertyName, propertyValue, collection = null) => {
    dispatch({ type: 'onPropertyChanged', propertyName, propertyValue, collection, index });
  };

  const onDeleteApprovalTypeLevelUserGroup = (collection, key) => {
    if (window.confirm(t('ApprovalTypes.ApprovalTypeLevelUserGroup.DeleteUserGroup'))) {
      dispatch({
        type: 'onDeleteItemCollection',
        collection,
        key,
        index
      });
    }
  };

  return (
    <TableRow>
      <TableCell>
        <Autocomplete
          fullWidth
          isClearable={false}
          value={item.userGroupId}
          simpleValue
          options={userGroups}
          onChange={event => onPropertyChanged('userGroupId', event, 'approvalTypeUserGroups')}
          label={t('ApprovalTypes.ApprovalTypeLevelUserGroup.UserGroup')}
          error={!isValid(validation.userGroupId)}
          helperText={getErrors(validation.userGroupId)}
          isSearchable={true}
        />
      </TableCell>
      <TableCell>
        {' '}
        <FormControlLabel
          control={<Checkbox checked={Boolean(item.isDefault)} onChange={event => setDefaultUserGroup(event.target.checked)} />}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Delete')}
          onClick={() => onDeleteApprovalTypeLevelUserGroup('approvalTypeUserGroups', item.approvalTypeUserGroupId)}
        />
      </TableCell>
    </TableRow>
  );
};

ApprovalTypeLevelUserGroupListItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  userGroups: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  validation: PropTypes.object
};

export default ApprovalTypeLevelUserGroupListItemComponent;
